import { createStore } from '@aibees/shared/store';
import { isEqual } from 'lodash-es';
import { HistoryStoreData as StoreData } from './types';

const useHistoryStore = createStore<StoreData>(
  'history-analysis-store',
  (set, get) => ({
    current: 0,
    history: [{}],
    init: (item) => {
      set(() => {
        return {
          history: [item],
          current: 0,
        };
      });
    },
    add: (item) => {
      set(({ history, current }) => {
        if (!isEqual(item, history[history.length - 1])) {
          return {
            history: [...history, ...[item]],
            current: current + 1,
          };
        }
      });
    },
    undo: () =>
      set(({ current }) => ({
        current: current ? current - 1 : 0,
      })),
    redo: () =>
      set(({ current }) => ({
        current: current + 1,
      })),
    reset: () => set(() => ({ history: [{}], current: 0 })),
  }),
  { persisted: false }
);

export default useHistoryStore;
